import { notifications } from '@mantine/notifications';
import { isAxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { useAppNotification } from '../hooks/useAppNotification';

// Mirrors the backend's per-file multipart limit.
export const MAX_UPLOAD_SIZE_MB = 50;

export const DOCUMENT_UPLOAD_ACCEPT =
  'application/pdf,image/png,image/jpeg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';

const PAYLOAD_TOO_LARGE = 413;

export function useUploadNotification() {
  const { t } = useTranslation();
  const notification = useAppNotification();

  const error = (err: Error) => {
    // The size refusal comes from the server's request limit with an empty body, so no error code names it.
    if (isAxiosError(err) && err.response?.status === PAYLOAD_TOO_LARGE) {
      notifications.show({
        color: 'red',
        title: t('notification.error.title'),
        message: t('notification.error.fileTooLarge', { maxSize: MAX_UPLOAD_SIZE_MB }),
      });
      return;
    }
    notification.error(err);
  };

  return { error, success: notification.success };
}
